import { useRef } from 'react';
import Calendar from 'react-calendar';
import './CustomCalendar.css';
import {
  formatEightDigitStringToDashForm,
  getYearMonthDateFromDate,
} from '../../function/replaceString';
import styled from 'styled-components';
import { IoIosArrowForward } from 'react-icons/io';
import { IoIosArrowBack } from 'react-icons/io';
import {
  getNextMonthStartDayFromDahedDateString,
  getPrevMonthStartDayFromDahedDateString,
} from './function/CustomCalendarFunction';

type CustomCalendarType = {
  /** YYYY-MM-DD */
  selectedDay: string;
  setSelectedDay: (date: Date) => void;
  markedDays: string[];
  hideControl?: boolean;
};

export const CustomCalendar = ({
  selectedDay,
  setSelectedDay,
  markedDays,
  hideControl,
}: CustomCalendarType) => {
  const calendarRef = useRef(null);
  const controlButtonClassName = hideControl
    ? 'control-button hide'
    : 'control-button';

  //각 날짜 타일(셀)에 이벤트라인 추가
  const TileGenerator = ({ date }: { date: Date }) => {
    const dateString = getYearMonthDateFromDate(date).dateString;

    const marked = markedDays.includes(dateString);

    return (
      <div
        style={{
          height: '19px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {marked && (
          <div
            style={{
              width: '8px',
              height: '8px',
              backgroundColor: '#ffa7a7',
              borderRadius: '100%',
            }}
          />
        )}
      </div>
    );
  };

  return (
    <div>
      <div className={'control-panel'}>
        <div
          style={{
            flex: 1,
            paddingTop: '3px',
            cursor: 'pointer',
            textAlign: 'center',
          }}
          onClick={() =>
            setSelectedDay(getPrevMonthStartDayFromDahedDateString(selectedDay))
          }
          className={controlButtonClassName}
        >
          <IoIosArrowBack size={22} />
        </div>
        {selectedDay.split('-').slice(0, 2).join('-')}
        <div
          style={{
            flex: 1,
            paddingTop: '3px',
            cursor: 'pointer',
            textAlign: 'center',
          }}
          onClick={() =>
            setSelectedDay(getNextMonthStartDayFromDahedDateString(selectedDay))
          }
          className={controlButtonClassName}
        >
          <IoIosArrowForward size={22} />
        </div>
      </div>
      <Calendar
        key={selectedDay}
        ref={calendarRef}
        className={'container'}
        onChange={(date) => setSelectedDay(date as Date)}
        //   defaultValue={new Date()}
        value={selectedDay}
        locale='ko'
        view='month'
        calendarType='gregory'
        showNavigation={false}
        showFixedNumberOfWeeks={false}
        showNeighboringMonth={false}
        // tileClassName={tileClassName}
        // formatShortWeekday={formatShortWeekday}
        // activeStartDate={calendarMonth}
        tileContent={({ date, view }) => {
          if (view === 'month') {
            return <TileGenerator date={date} />;
          }
          return null; // 기본 콘텐츠를 제거
        }}
      />
    </div>
  );
};

const ControlPanel = styled.div``;
